import { useEffect, useState } from "react";
import { getConnectivityOnline, subscribeConnectivity } from "@/domains/offline/connectivity/connectivityStore";

export function useConnectivity(): boolean {
  const [isOnline, setIsOnline] = useState(getConnectivityOnline);

  useEffect(() => subscribeConnectivity(setIsOnline), []);

  return isOnline;
}
